jQuery(function($) {
    if($('div#location-map').length) {
		initMap();
	}
});

function initMap() {	
    var mapelement = jQuery('#location-map');
	var marks = mapelement.find('.location-marker');
	var setlat = Number(mapelement.data('lat'));
	var setlng = Number(mapelement.data('lng'));
	var setzoom = mapelement.data('zoom');
			
	if(isNaN(setlat) || setlat === undefined) setlat = 0;
	if(isNaN(setlng) || setlng === undefined) setlng = 0;
	if(setzoom == '' || setzoom == 'auto' || setzoom === undefined) setzoom = 0;
					
	var map = new google.maps.Map(document.getElementById('location-map'), {
		center: {lat: setlat, lng: setlng},
		zoom: setzoom,
		minZoom: 8,
		maxZoom: 15,
		zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP
        },
		scaleControl: false,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false,
		styles: [
			{
				featureType: 'poi',
				elementType: 'labels',
				stylers: [{visibility: 'off'}]
			},
			{
				featureType: 'transit',
				elementType: 'labels',
				stylers: [{visibility: 'off'}]
			}
		]
	});
	
	var bounds = new google.maps.LatLngBounds();
	var infowindow = new google.maps.InfoWindow(); 
	var markers = [];

	marks.each(function() {
		var element = jQuery(this);
		var latlng = new google.maps.LatLng(element.data('lat'), element.data('lng'));
		var mark = new google.maps.Marker({
			position: latlng
		});
		var type = element.data('type');
        var image = {
            url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 40 54'%3E%3Cpath fill='%23ef7800' d='M20,53.7s20-21.7,20-33.3S31,.3,20,.3,0,9.3,0,20.3s20,33.3,20,33.3ZM20,13.7c3.7,0,6.7,3,6.7,6.7s-3,6.7-6.7,6.7-6.7-3-6.7-6.7,3-6.7,6.7-6.7Z'/%3E%3C/svg%3E",
            scaledSize: new google.maps.Size(40,54)
        }
        mark.setIcon(image);

		var text = element.html();
		
		bounds.extend(latlng);
		
		if(text !== null && text !== '') {
			google.maps.event.addListener(mark, 'mouseover', function() {
				infowindow.close();
				infowindow.setContent(text);
				infowindow.open(map, mark);
			});

			google.maps.event.addListener(mark, 'click', function() {
				infowindow.close();
				infowindow.setContent(text);
				infowindow.open(map, mark);
			});
		}
		
		mark.setMap(map);
		
		markers.push(mark);
	});
	
	if(setlat == 0 && setlng == 0) {
		map.setCenter(bounds.getCenter());
	}
	
	if(setzoom) {
		map.setZoom(setzoom);
	} else {
		map.fitBounds(bounds);
	}

	google.maps.event.addListener(infowindow, 'domready', function() {
        jQuery('.gm-style-iw-d').css({'overflow': 'visible'});
	});
	
	return map;
}